export default "__VITE_ASSET__B58tYW6e__"